import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { Building2 } from "lucide-react";
import { dataApi } from "@/lib/api/admin-api";
import { useLingui } from "@lingui/react/macro";
import { StatCard } from "@/components/common/StatCard";

export function OrganizationStats() {
  const { t } = useLingui();
  const { isAuthenticated } = useAuth();

  const { data: stats, isLoading } = useQuery({
    queryKey: ["organizations", "stats"],
    queryFn: () => dataApi.getOrganizationsStats({ adminScope: true }),
    enabled: isAuthenticated,
  });

  return (
    <div className="grid grid-cols-3 gap-3 p-3 bg-(--color-surface-muted) rounded-lg">
      <StatCard label={t`Total Organizations`} value={stats?.total ?? 0} icon={Building2} loading={isLoading} />
      <StatCard label={t`Active`} value={stats?.active ?? 0} icon={Building2} loading={isLoading} />
      <StatCard label={t`Inactive`} value={stats?.inactive ?? 0} icon={Building2} loading={isLoading} />
    </div>
  );
}
